/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PersonDetails/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import Email from './Email/index'
import Phone from './Phone/index'
import React from 'react'
import TysiaProfileValueWithLabelText from 'DesignSystem/TysiaProfileElements/TysiaProfileValueWithLabelText/index'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function PersonDetails({
  children,
  viewPath = "/DesignSystem/LeadPreview/Content/PersonDetails"
  
}) {
let leadMetadataPersonFirstnameValueData = fromData.useDataValue({ viewPath,
context: 'lead',
path: 'metadata.person.firstName',
})
let leadMetadataPersonLastnameValueData = fromData.useDataValue({ viewPath,
context: 'lead',
path: 'metadata.person.lastName',
})
let leadMetadataPersonBirthdateValueData = fromData.useDataFormat({ viewPath,
context: 'lead',
path: 'metadata.person.birthDate',
format: fromFormat.dateISOIn,
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaProfileValueWithLabelText
  viewPath={`${viewPath}/TysiaProfileValueWithLabelText`}
 label="First Name"
 data="lead.metadata.person.firstName"
 value={leadMetadataPersonFirstnameValueData}
/>
<TysiaProfileValueWithLabelText
  viewPath={`${viewPath}/TysiaProfileValueWithLabelText`}
 label="Last Name"
 data="lead.metadata.person.lastName"
 value={leadMetadataPersonLastnameValueData}
/>
<TysiaProfileValueWithLabelText
  viewPath={`${viewPath}/TysiaProfileValueWithLabelText`}
 label="Date of Birth"
 data="lead.metadata.person.birthDate"
 format="/Data/format.js dateISOIn"
 value={leadMetadataPersonBirthdateValueData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceS}
 text="Email"
 weight="semibold"
 marginRight={dtSpaceS}
/>
<Email
  viewPath={`${viewPath}/Email`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceS}
 text="Phone"
 weight="semibold"
 marginRight={dtSpaceS}
/>
<Phone
  viewPath={`${viewPath}/Phone`}
/>
{children}
</React.Fragment>)
}